import React from 'react';

export default function DebugBar({ uid, profile, dayKey, subActive }) {
  if (import.meta?.env?.MODE !== 'development') return null;
  const style = {
    position: 'fixed', 
    left: 8, 
    bottom: 8, 
    fontSize: 12,
    background: 'rgba(0,0,0,0.6)', 
    color: '#fff', 
    padding: '6px 8px',
    borderRadius: 6, 
    zIndex: 9999
  };
  return (
    <div style={style}>
      <div><b>UID:</b> {uid || '(null)'}</div>
      <div><b>Profile:</b> {profile || '(n/a)'}</div>
      <div><b>dayKey:</b> {dayKey || '(n/a)'}</div>
      <div><b>sub:</b> {subActive ? 'on' : 'off'}</div>
    </div>
  );
}
